import styled from "@emotion/styled";
import { Paper } from "@mui/material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  margin: "auto 0px",
  color: theme.palette.text.secondary,
  borderRadius: "15px",
  border: "0.3px solid #ccc",
  // width: '242px',
  minHeight: "100px",
}));

export const MyPaper = styled(StyledPaper)(({ theme }) => ({
  padding: theme.spacing(5.4),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const MyBarChartPaper = styled(StyledPaper)(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const MyBarChartPaper2 = styled(StyledPaper)(({ theme }) => ({
  padding: `${theme.spacing(1)}`,
  paddingLeft: `${theme.spacing(2)}`,
  paddingRight: `${theme.spacing(2)}`,
}));

export const MyStaffChartPaper = styled(StyledPaper)(({ theme }) => ({
  padding: theme.spacing(2),
  minHeight: "300px",
}));

export const MyPieChartPaper = styled(StyledPaper)(({ theme }) => ({
  padding: theme.spacing(2),
}));
